import { GoogleTagEventKeysPort } from '../../ports/GoogleTagEventKeysPort';
import { trackConversionEvent } from '../../../tracking/gtag';

export class TrackGoogleEventUseCase {
  constructor(private readonly eventKeysPort: GoogleTagEventKeysPort) {}

  trackDisplayOffer(): void {
    trackConversionEvent(this.eventKeysPort.getDisplayOfferEventKey(), '');
  }

  trackEnterOnboarding(): void {
    trackConversionEvent(this.eventKeysPort.getEnterOnboardingEventKey(), '');
  }

  trackSubmitOffer(): void {
    trackConversionEvent(this.eventKeysPort.getSubmitOfferEventKey(), '');
  }

  trackSubmitOrder(): void {
    trackConversionEvent(this.eventKeysPort.getSubmitOrderEventKey(), '');
  }
}
